import React from 'react';
import { Helmet } from 'react-helmet';
import styles from './style.css';

const BrightcoveVideoPlayer = ({ videoID, accountID, playerID, ...rest }) => {
  return (
    <div className="brightcove-player">
      <video
        data-video-id={videoID}
        data-account={accountID}
        data-player={playerID}
        data-embed="default"
        data-application-id
        className="video-js"
        controls
        {...rest}
      />
      <Helmet>
        <script
          crossOrigin
          data-id="brightcove-js"
          src={`https://players.brightcove.net/${accountID}/${playerID}_default/index.min.js`}
        />
      </Helmet>
      <style jsx>{styles}</style>
    </div>
  );
};

export default BrightcoveVideoPlayer;
